import React, { useEffect, useState } from 'react';

const AppOfflineIndicator = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOffline = () => setIsOffline(true);
    const handleOnline = () => setIsOffline(false);

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);
  return (
    <div className="bg-red-500  w-full sticky top-0 z-50 ">
      {isOffline && (
        <div className="  text-white text-center px-4 py-1 text-xs shadow-md">
          You are offline. Some features may not be available.
        </div>
      )}
    </div>
  );
};

export default AppOfflineIndicator;
